// HMAC-based Key Derivation Function (RFC 5869). Used internally by the KEM
// suites to derive shared secrets from raw DH output and to combine component
// secrets in hybrid constructions via domain-separated extract-then-expand.
import { hkdf as nobleHkdf, extract as nobleExtract, expand as nobleExpand } from '@noble/hashes/hkdf.js';
import { sha256 } from '@noble/hashes/sha2.js';
export const hkdfSha256 = {
    name: 'hkdf-sha256',
    extract(ikm, salt) {
        return nobleExtract(sha256, ikm, salt);
    },
    expand(prk, info, length) {
        return nobleExpand(sha256, prk, info, length);
    },
    deriveKey(ikm, salt, info, length) {
        return nobleHkdf(sha256, ikm, salt, info, length);
    }
};
